/**
 * Created by kz on 28.06.17.
 */
export const all = (state) => {
  return state.all
}



// WEBPACK FOOTER //
// ./src/store/modules/companies/getters.js